import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createSlots as _createSlots, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed, ref } from "vue";
import {
  timStore,
  appStore,
  artifactStore,
  traceApiStore,
  traceSaveStore,
} from "@/hooks";
import {
  Typography,
  ArtifactInput,
  TypeDirectionInput,
  FlexBox,
  ExpansionItem,
  PanelCard,
  TextButton,
  DetailsPanel,
  Separator,
} from "@/components/common";
import { ArtifactBodyDisplay } from "@/components/artifact/display";
import TextInput from "@/components/common/input/TextInput.vue";


/**
 * Allows for creating trace links.
 */
const __default__ = {
  name: "SaveTraceLinkPanel",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const loading = ref(false);

const artifactTypes = computed(() => timStore.artifactTypes);

const sourceArtifact = computed(() =>
  traceSaveStore.sourceIds
    ? artifactStore.getArtifactById(traceSaveStore.sourceIds[0])
    : undefined
);
const targetArtifact = computed(() =>
  traceSaveStore.targetIds
    ? artifactStore.getArtifactById(traceSaveStore.targetIds[0])
    : undefined
);

/**
 * Creates a trace link from the given artifacts.
 */
async function handleSubmit(): Promise<void> {
  loading.value = true;

  await traceApiStore.handleCreateAll();

  loading.value = false;
  appStore.closeSidePanels();
  traceSaveStore.resetTrace();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DetailsPanel), {
    panel: "saveTrace",
    "data-cy": "panel-trace-save"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(PanelCard), {
        title: "Save Trace Link",
        borderless: ""
      }, {
        actions: _withCtx(() => [
          _createVNode(_unref(FlexBox), {
            "full-width": "",
            justify: "end"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(TextButton), {
                label: "Create",
                icon: "save",
                color: "primary",
                disabled: !_unref(traceSaveStore).canSave,
                loading: loading.value,
                "data-cy": "button-trace-save",
                onClick: handleSubmit
              }, null, 8, ["disabled", "loading"])
            ]),
            _: 1
          })
        ]),
        default: _withCtx(() => [
          _createVNode(_unref(ArtifactInput), {
            modelValue: _unref(traceSaveStore).targetIds,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(traceSaveStore).targetIds) = $event)),
            multiple: "",
            label: "Parent Artifacts",
            "hidden-artifact-ids": _unref(traceSaveStore).hiddenTargetIds,
            "default-hidden-types": _unref(traceSaveStore).defaultHiddenTargetTypes,
            "data-cy": "button-trace-save-target"
          }, _createSlots({ _: 2 }, [
            (!!sourceArtifact.value)
              ? {
                  name: "before-options",
                  fn: _withCtx(() => [
                    _createVNode(_unref(Typography), {
                      variant: "caption",
                      value: "Child Artifact",
                      l: "2"
                    }),
                    _createVNode(_unref(Separator), { class: "q-mx-sm" }),
                    _createVNode(_unref(ArtifactBodyDisplay), {
                      "display-title": "",
                      artifact: sourceArtifact.value
                    }, null, 8, ["artifact"]),
                    _createVNode(_unref(Typography), {
                      variant: "caption",
                      value: "Parent Artifacts",
                      l: "2"
                    }),
                    _createVNode(_unref(Separator), { class: "q-mx-sm" })
                  ]),
                  key: "0"
                }
              : undefined
          ]), 1032, ["modelValue", "hidden-artifact-ids", "default-hidden-types"]),
          _createVNode(_unref(ArtifactInput), {
            modelValue: _unref(traceSaveStore).sourceIds,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(traceSaveStore).sourceIds) = $event)),
            multiple: "",
            label: "Child Artifacts",
            class: "q-my-md",
            "hidden-artifact-ids": _unref(traceSaveStore).hiddenSourceIds,
            "default-hidden-types": _unref(traceSaveStore).defaultHiddenSourceTypes,
            "data-cy": "button-trace-save-source"
          }, _createSlots({ _: 2 }, [
            (!!targetArtifact.value)
              ? {
                  name: "before-options",
                  fn: _withCtx(() => [
                    _createVNode(_unref(Typography), {
                      variant: "caption",
                      value: "Parent Artifact",
                      l: "2"
                    }),
                    _createVNode(_unref(ArtifactBodyDisplay), {
                      "display-title": "",
                      artifact: targetArtifact.value
                    }, null, 8, ["artifact"]),
                    _createVNode(_unref(Typography), {
                      variant: "caption",
                      value: "Child Artifacts",
                      l: "2"
                    })
                  ]),
                  key: "0"
                }
              : undefined
          ]), 1032, ["modelValue", "hidden-artifact-ids", "default-hidden-types"]),
          _createVNode(TextInput, {
            modelValue: _unref(traceSaveStore).explanation,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(traceSaveStore).explanation) = $event)),
            label: "Explanation",
            class: "q-my-md",
            type: "textarea",
            "data-cy": "input-trace-explanation"
          }, null, 8, ["modelValue"]),
          _createVNode(_unref(ExpansionItem), {
            label: "Allowed Trace Directions",
            "data-cy": "panel-trace-directions"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(artifactTypes.value, (type) => {
                return (_openBlock(), _createBlock(_unref(TypeDirectionInput), {
                  key: type.typeId,
                  "artifact-type": type
                }, null, 8, ["artifact-type"]))
              }), 128))
            ]),
            _: 1
          }),
          (!loading.value)
            ? (_openBlock(), _createBlock(_unref(Typography), {
                key: 0,
                el: "p",
                color: "negative",
                class: "q-my-md",
                value: _unref(traceSaveStore).errorMessage
              }, null, 8, ["value"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})